var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5218 10.1988C17.8522 10.4486 17.9175 10.9189 17.6678 11.2494C17.6406 11.2852 17.6109 11.318 17.5791 11.3476C17.445 11.4731 17.2647 11.55 17.0665 11.55H6.96047C6.54625 11.55 6.21047 11.2143 6.21047 10.8C6.21047 10.3858 6.54625 10.05 6.96047 10.05H14.8376L12.5192 8.29736C12.1888 8.04756 12.1234 7.57721 12.3732 7.24679C12.623 6.91637 13.0933 6.85101 13.4238 7.1008L17.5218 10.1988Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54769 14.1013C6.21727 13.8515 6.15191 13.3811 6.4017 13.0507C6.42882 13.0148 6.45854 12.9821 6.4904 12.9525C6.6245 12.8269 6.80476 12.75 7.00299 12.75H17.109C17.5232 12.75 17.859 13.0858 17.859 13.5C17.859 13.9142 17.5232 14.25 17.109 14.25H9.23182L11.5503 16.0027C11.8807 16.2525 11.946 16.7228 11.6963 17.0533C11.4465 17.3837 10.9761 17.449 10.6457 17.1993L6.54769 14.1013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.344f157a6d827103ce578f4c89434257.svg";
export { ForwardRef as ReactComponent };